// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Amount$LiveRoom from "../Amount.bs.js";
import * as I18next$LiveRoom from "../bindings/I18next.bs.js";
import * as SvgImages$LiveRoom from "../assets/img/SvgImages.bs.js";
import * as PropSpread$LiveRoom from "./PropSpread.bs.js";
import * as CommonStyles$LiveRoom from "../styles/CommonStyles.bs.js";
import * as Utils_Session$LiveRoom from "../Utils/Utils_Session.bs.js";
import * as SterlingTokens$LiveRoom from "../bindings/SterlingTokens.bs.js";
import * as StyleConstants$LiveRoom from "../styles/StyleConstants.bs.js";
import * as SterlingTypography$LiveRoom from "../bindings/SterlingTypography.bs.js";
import * as BidCapLearnMoreModal$LiveRoom from "./Modal/BidCapLearnMoreModal.bs.js";

var white = SterlingTokens$LiveRoom.Colors.primaryWhite_nohashtag;

var orange = SterlingTokens$LiveRoom.Colors.alertOrange20_nohashtag;

var green = SterlingTokens$LiveRoom.Colors.alertGreen20_nohashtag;

var red = SterlingTokens$LiveRoom.Colors.alertRed20_nohashtag;

var blue = SterlingTokens$LiveRoom.Colors.primaryBlue10_nohashtag;

var gold = SterlingTokens$LiveRoom.Colors.primaryGold60_nohashtag;

function FeedMessageBox$Paragraph14Regular(props) {
  return React.createElement(SterlingTypography$LiveRoom.Paragraph14Regular.make, {
              className: Curry._1(Css.merge, {
                    hd: Curry._1(Css.style, {
                          hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey80_nohashtag)),
                          tl: /* [] */0
                        }),
                    tl: {
                      hd: Curry._1(Css.style, Belt_Option.getWithDefault(props.additionalStyles, /* [] */0)),
                      tl: /* [] */0
                    }
                  }),
              children: props.text
            });
}

var Paragraph14Regular = {
  make: FeedMessageBox$Paragraph14Regular
};

function FeedMessageBox$Paragraph12Regular(props) {
  return React.createElement(SterlingTypography$LiveRoom.Paragraph12Regular.make, {
              className: Curry._1(Css.merge, {
                    hd: Curry._1(Css.style, {
                          hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey100_nohashtag)),
                          tl: /* [] */0
                        }),
                    tl: {
                      hd: Curry._1(Css.style, Belt_Option.getWithDefault(props.additionalStyles, /* [] */0)),
                      tl: /* [] */0
                    }
                  }),
              children: props.text
            });
}

var Paragraph12Regular = {
  make: FeedMessageBox$Paragraph12Regular
};

function FeedMessageBox$Label14Medium(props) {
  return React.createElement(SterlingTypography$LiveRoom.Label14Medium.make, {
              className: Curry._1(Css.style, {
                    hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryBlack_nohashtag)),
                    tl: /* [] */0
                  }),
              children: props.text
            });
}

var Label14Medium = {
  make: FeedMessageBox$Label14Medium
};

function FeedMessageBox$Label12Medium(props) {
  return React.createElement(SterlingTypography$LiveRoom.Label12Medium.make, {
              className: Curry._1(Css.style, {
                    hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryBlack_nohashtag)),
                    tl: /* [] */0
                  }),
              children: props.text
            });
}

var Label12Medium = {
  make: FeedMessageBox$Label12Medium
};

function FeedMessageBox$BoxContainer(props) {
  var boxColor = props.boxColor;
  var boxColor$1 = boxColor !== undefined ? boxColor : white;
  return React.createElement(PropSpread$LiveRoom.make, {
              data: {
                hd: {
                  TAG: /* TestId */1,
                  _0: props.testId + "MessageBox"
                },
                tl: /* [] */0
              },
              children: React.createElement("div", {
                    className: Curry._1(Css.style, {
                          hd: Css.padding2(Css.px(8), Css.px(4)),
                          tl: {
                            hd: Css.backgroundColor(Css.hex(boxColor$1)),
                            tl: {
                              hd: Css.display("block"),
                              tl: {
                                hd: Css.textAlign("center"),
                                tl: {
                                  hd: Css.borderRadius(Css.px(4)),
                                  tl: /* [] */0
                                }
                              }
                            }
                          }
                        })
                  }, props.children)
            });
}

var BoxContainer = {
  make: FeedMessageBox$BoxContainer
};

function FeedMessageBox$BidCapLimit(props) {
  var setModalToShow = props.setModalToShow;
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t = match.t;
  return React.createElement(FeedMessageBox$BoxContainer, {
              testId: "BidCapLimit",
              boxColor: orange,
              children: null
            }, React.createElement(FeedMessageBox$Paragraph14Regular, {
                  text: Curry._1(t, "BidCap_BidLimitReached")
                }), React.createElement(SterlingTypography$LiveRoom.ButtonLink12Regular.make, {
                  className: Curry._1(Css.style, {
                        hd: Css.important(Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey100_nohashtag))),
                        tl: {
                          hd: Css.important(Css.textDecorationLine("none")),
                          tl: {
                            hd: Css.important(Css.fontWeight({
                                      NAME: "num",
                                      VAL: 600
                                    })),
                            tl: /* [] */0
                          }
                        }
                      }),
                  onClick: (function (param) {
                      Curry._1(setModalToShow, (function (param) {
                              return /* BidCapLearnMoreModal */1;
                            }));
                    }),
                  children: Curry._1(t, "Common_learnMore")
                }));
}

var BidCapLimit = {
  make: FeedMessageBox$BidCapLimit
};

function FeedMessageBox$ConfirmingResults(props) {
  var match = I18next$LiveRoom.useTranslation(undefined);
  return React.createElement(FeedMessageBox$BoxContainer, {
              testId: "ConfirmingResults",
              children: React.createElement("div", {
                    className: Curry._1(Css.style, {
                          hd: Css.display("flex"),
                          tl: {
                            hd: Css.justifyContent("center"),
                            tl: /* [] */0
                          }
                        })
                  }, React.createElement(SvgImages$LiveRoom.LoadingArrows.make, {}), React.createElement(FeedMessageBox$Paragraph14Regular, {
                        text: Curry._1(match.t, "FeedButton_confirmingResults"),
                        additionalStyles: {
                          hd: Css.marginLeft(Css.px(8)),
                          tl: /* [] */0
                        }
                      }))
            });
}

var ConfirmingResults = {
  make: FeedMessageBox$ConfirmingResults
};

function FeedMessageBox$UserBidStateInfo(props) {
  var setModalToShow = props.setModalToShow;
  var isBidCapReached = props.isBidCapReached;
  var baseCurrency = props.baseCurrency;
  var finalPrice = props.finalPrice;
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t2 = match.t2;
  var t = match.t;
  var match$1 = Belt_Option.map(props.latestBid, (function (x) {
          return x.bidState;
        }));
  if (match$1 !== undefined) {
    if (match$1 === "BidAheadOfYou" || match$1 === "Outbid") {
      if (isBidCapReached) {
        return React.createElement(FeedMessageBox$BidCapLimit, {
                    setModalToShow: setModalToShow
                  });
      } else {
        return React.createElement(FeedMessageBox$BoxContainer, {
                    testId: "OutBid",
                    boxColor: orange,
                    children: null
                  }, React.createElement(FeedMessageBox$Label12Medium, {
                        text: Curry._1(t, "MessageBox_YouHaveBeenOutBid")
                      }), React.createElement(FeedMessageBox$Paragraph12Regular, {
                        text: Curry._2(t2, "MessageBox_IncreaseYourBid", {
                              amount: props.bidAsk,
                              currency: baseCurrency
                            })
                      }));
      }
    }
    if (match$1 === "Absentee") {
      return React.createElement(FeedMessageBox$BoxContainer, {
                  testId: "AbsenteeBid",
                  boxColor: blue,
                  children: null
                }, React.createElement(FeedMessageBox$Label12Medium, {
                      text: Curry._1(t, "MessageBox_YourAbsenteeBid")
                    }), React.createElement(FeedMessageBox$Paragraph12Regular, {
                      text: props.myCurrentBid + " " + baseCurrency
                    }));
    }
    if (match$1 === "CurrentBid" || match$1 === "MaxBid") {
      return React.createElement(FeedMessageBox$BoxContainer, {
                  testId: "CurrentBid",
                  boxColor: green,
                  children: React.createElement(FeedMessageBox$Label14Medium, {
                        text: Curry._1(t, "MessageBox_YouHaveTheBid")
                      })
                });
    }
    if (match$1 === "Won") {
      return React.createElement(FeedMessageBox$BoxContainer, {
                  testId: "Won",
                  boxColor: gold,
                  children: null
                }, React.createElement(FeedMessageBox$Label14Medium, {
                      text: Curry._1(t, "FeedButton_youHaveWonThislot")
                    }), React.createElement(FeedMessageBox$Paragraph12Regular, {
                      text: Curry._2(t2, "MessageBox_LotSoldToYouFor", {
                            amount: finalPrice,
                            currency: baseCurrency
                          })
                    }));
    }
    if (match$1 === "Lost") {
      return React.createElement(FeedMessageBox$BoxContainer, {
                  testId: "Lost",
                  boxColor: red,
                  children: null
                }, React.createElement(FeedMessageBox$Label14Medium, {
                      text: Curry._1(t, "LotListContainer_youHaveLostThislot")
                    }), props.isLotSold ? React.createElement(FeedMessageBox$Paragraph12Regular, {
                        text: Curry._2(t2, "MessageBox_LotSoldFor", {
                              amount: finalPrice,
                              currency: baseCurrency
                            })
                      }) : null);
    }
    
  }
  if (isBidCapReached) {
    return React.createElement(FeedMessageBox$BidCapLimit, {
                setModalToShow: setModalToShow
              });
  } else {
    return null;
  }
}

var UserBidStateInfo = {
  make: FeedMessageBox$UserBidStateInfo
};

function FeedMessageBox(props) {
  var isBidCapReached = props.isBidCapReached;
  var fragment = props.fragment;
  var match = React.useState(function () {
        return /* NoModal */0;
      });
  var setModalToShow = match[1];
  var match$1 = I18next$LiveRoom.useTranslation(undefined);
  var t2 = match$1.t2;
  var t = match$1.t;
  var baseCurrency = Amount$LiveRoom.currencyToString(fragment.auction.currency);
  var $$location = Belt_Option.mapWithDefault(fragment.auction.location, "", (function (x) {
          return x.name;
        }));
  var isLotWithdrawn = fragment.withdrawnState.state === "Withdrawn";
  var isLotClosed = Belt_Option.mapWithDefault(fragment.bidState, false, (function (x) {
          return x.isClosed;
        }));
  var isLotPremium = fragment.premiumLotState.isPremium;
  var premiumWhitelisted = fragment.premiumLotState.userIsWhitelisted;
  var myLatestBid = fragment.latestBid.bid;
  var match$2 = Belt_Option.mapWithDefault(fragment.bidState, undefined, (function (x) {
          return x.sold;
        }));
  var match$3;
  if (match$2 !== undefined && typeof match$2 === "object" && match$2.NAME === "ResultVisible") {
    var match$4 = match$2.VAL;
    match$3 = [
      match$4.isSold,
      Amount$LiveRoom.format(Belt_Option.mapWithDefault(match$4.premiums, "0", (function (x) {
                  return Belt_Option.mapWithDefault(x.finalPrice, "0", (function (x) {
                                return x.amount;
                              }));
                })))
    ];
  } else {
    match$3 = [
      false,
      "0"
    ];
  }
  var isLotSold = match$3[0];
  var myCurrentBid = Amount$LiveRoom.format(Belt_Option.mapWithDefault(fragment.latestBid.bid, "0", (function (x) {
              return x.amount.amount;
            })));
  var bidAsk = Amount$LiveRoom.format(Belt_Option.getWithDefault(Belt_Option.mapWithDefault(fragment.bidState, undefined, (function (x) {
                  return x.bidAsk;
                })), "0"));
  var isSessionClosed = Belt_Option.mapWithDefault(fragment.session, "PreOpen", (function (x) {
          return x.state.state;
        })) === "Closed";
  var isOnlineBidAvailable = Belt_Option.mapWithDefault(fragment.auction.bidTypeAvailability, true, (function (x) {
          return x.online.isAvailable;
        }));
  var match$5 = Belt_Option.map(fragment.bidState, (function (x) {
          return x.bidType;
        }));
  var isLotUpcoming = match$5 !== undefined && typeof match$5 === "object" && match$5.NAME === "LiveBidType" ? match$5.VAL.liveBidPhase === "Upcoming" : false;
  var match$6 = Belt_Option.map(fragment.bidState, (function (x) {
          return x.bidType;
        }));
  var isConfirmingResults = match$6 !== undefined && typeof match$6 === "object" && match$6.NAME === "LiveBidType" ? match$6.VAL.liveBidPhase === "ConfirmingResult" : false;
  var match$7 = Belt_Option.map(fragment.bidState, (function (x) {
          return x.bidType;
        }));
  var isLotLive = match$7 !== undefined && typeof match$7 === "object" && match$7.NAME === "LiveBidType" ? match$7.VAL.liveBidPhase === "Live" : false;
  return React.createElement("div", {
              className: Curry._1(Css.style, {
                    hd: Css.margin2(Css.px(4), Css.px(0)),
                    tl: {
                      hd: StyleConstants$LiveRoom.defaultBorder("top", Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey30_nohashtag), undefined),
                      tl: {
                        hd: Css.paddingTop(Css.px(16)),
                        tl: {
                          hd: CommonStyles$LiveRoom.mediaV2(/* Mobile */1, {
                                hd: Css.paddingTop(Css.px(4)),
                                tl: /* [] */0
                              }),
                          tl: /* [] */0
                        }
                      }
                    }
                  })
            }, isOnlineBidAvailable ? (
                isLotWithdrawn ? React.createElement(FeedMessageBox$BoxContainer, {
                        testId: "LotWithdrawn",
                        children: React.createElement(FeedMessageBox$Paragraph14Regular, {
                              text: Curry._1(t, "FeedButton_thisLotIsWithdrawn")
                            })
                      }) : (
                    isConfirmingResults ? React.createElement(FeedMessageBox$ConfirmingResults, {}) : (
                        Belt_Option.isNone(myLatestBid) && isLotClosed ? (
                            isLotSold ? React.createElement(FeedMessageBox$BoxContainer, {
                                    testId: "LotSold",
                                    children: React.createElement(FeedMessageBox$Paragraph14Regular, {
                                          text: Curry._1(t, "Common_lotSold")
                                        })
                                  }) : React.createElement(FeedMessageBox$BoxContainer, {
                                    testId: "LotClosed",
                                    children: React.createElement(FeedMessageBox$Paragraph14Regular, {
                                          text: Curry._1(t, "Common_lotClosed")
                                        })
                                  })
                          ) : (
                            Belt_Option.isNone(myLatestBid) && isLotPremium && !premiumWhitelisted ? React.createElement(FeedMessageBox$BoxContainer, {
                                    testId: "PremiumLot",
                                    children: React.createElement(FeedMessageBox$Paragraph14Regular, {
                                          text: Curry._1(t, "MessageBox_PremiumLotWhitelistedOnly")
                                        })
                                  }) : (
                                Belt_Option.isSome(myLatestBid) ? React.createElement(FeedMessageBox$UserBidStateInfo, {
                                        latestBid: myLatestBid,
                                        bidAsk: bidAsk,
                                        finalPrice: match$3[1],
                                        baseCurrency: baseCurrency,
                                        myCurrentBid: myCurrentBid,
                                        isBidCapReached: isBidCapReached,
                                        isLotSold: isLotSold,
                                        setModalToShow: setModalToShow
                                      }) : (
                                    isBidCapReached ? React.createElement(FeedMessageBox$BidCapLimit, {
                                            setModalToShow: setModalToShow
                                          }) : (
                                        isLotUpcoming ? React.createElement(FeedMessageBox$BoxContainer, {
                                                testId: "WaitingForLotToOpen",
                                                children: React.createElement(FeedMessageBox$Paragraph14Regular, {
                                                      text: Curry._1(t, "FeedButton_waitingForLotToOpen")
                                                    })
                                              }) : (
                                            isSessionClosed && !isLotLive ? React.createElement(FeedMessageBox$BoxContainer, {
                                                    testId: "SessionClosed",
                                                    children: React.createElement(FeedMessageBox$Paragraph14Regular, {
                                                          text: Curry._2(t2, "MessageBox_SessionClosed", {
                                                                SessionName: Utils_Session$LiveRoom.getSessionName(Belt_Option.mapWithDefault(fragment.session, undefined, (function (x) {
                                                                            return x.title;
                                                                          })), Belt_Option.mapWithDefault(fragment.session, 0, (function (x) {
                                                                            return x.sessionId;
                                                                          })), t2)
                                                              })
                                                        })
                                                  }) : null
                                          )
                                      )
                                  )
                              )
                          )
                      )
                  )
              ) : React.createElement(FeedMessageBox$BoxContainer, {
                    testId: "OnlineBiddingNotAvailable",
                    children: React.createElement(FeedMessageBox$Paragraph14Regular, {
                          text: Curry._1(t, "FeedButton_onlineBiddingUnavailable")
                        })
                  }), match[0] ? React.createElement(BidCapLearnMoreModal$LiveRoom.make, {
                    location: $$location,
                    onClose: (function (param) {
                        Curry._1(setModalToShow, (function (param) {
                                return /* NoModal */0;
                              }));
                      })
                  }) : null);
}

var make = FeedMessageBox;

export {
  white ,
  orange ,
  green ,
  red ,
  blue ,
  gold ,
  Paragraph14Regular ,
  Paragraph12Regular ,
  Label14Medium ,
  Label12Medium ,
  BoxContainer ,
  BidCapLimit ,
  ConfirmingResults ,
  UserBidStateInfo ,
  make ,
}
/* Css Not a pure module */
